document.addEventListener("DOMContentLoaded", function() {
  const mobileSliders = document.querySelectorAll(".product__media-list.slider--mobile");

  mobileSliders.forEach((slider) => {
    slider.style.display = "flex";
    slider.style.overflowX = "auto";
    slider.style.scrollSnapType = "x mandatory";
    slider.style.gap = "8px";
    slider.style.scrollBehavior = "smooth";
    slider.style.webkitOverflowScrolling = "touch";

    const slides = slider.querySelectorAll("li, .product__media-item");
    slides.forEach((slide) => {
      slide.style.flex = "0 0 85%";
      slide.style.scrollSnapAlign = "center";
    });
  });
});
